import React, { useState } from "react";
// import { Box, TextField, Button, Typography } from "@mui/material";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth } from "../Context/AuthContext";
import CloseIcon from "@mui/icons-material/Close";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
const apiUrl = process.env.REACT_APP_API_REST_URL;

const InsSignin = ({ onLogin }) => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const { setAuthToken, setUserEmail } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting, isValid },
    // setError,
  } = useForm();

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      vendor: "zopper",
      type: "b2c",
      product: "optimus",
    };

    try {
      const response = await axios.post(
        `${apiUrl}/CCE/api/v1/authEngine/insuranceLogin`,
        payload
      );
      if (response?.data?.response?.data?.redirection_url) {
        // window.open(response.data.response.data.redirection_url, "_blank");
        window.location.href = response.data.response.data.redirection_url;
        reset();
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        const errorData = error.response.data;

        if (
          errorData.status === false &&
          errorData.statusCode === "101" &&
          errorData.statusMessage === "Validation Error"
        ) {
          if (errorData.response.status === "USER_NOT_EXIST") {
            toast.error("User with this email does not exist in the system!");
          } else if (errorData.response.status === "INVALID_CREDENTIAL") {
            toast.error("Invalid password!");
          }
        }
      } else {
        console.error("Error:", error.message);
        toast.error(
          "We regret to inform that there is some issue during logging, please try later or inform your Wealth Manager regarding the same. Thank you."
        );
      }
    }
  };

  const handleCancel = () => {
    navigate("/insurance-register");
  };

  const handleClick = () => {
    console.log("Clicking the forget Password");
    // Handle forgot password link click here
    // You can navigate to a reset password page or show a dialog for password reset
    navigate("/forgotpassword");
  };

  return (
    <>
      {isSmallScreen ? (
        <span>
          {" "}
          <Box sx={styles.formboxresponsive}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>
            <div style={{ margin: "0px 0px 10px 0px" }}>Welcome to Amigo!</div>
            <div style={{ fontSize: "22px", marginBottom: "25px" }}>
              <b>Sign in to your Account</b>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box sx={{ marginBottom: "8px" }}>
                <TextField
                  sx={styles.textfieldres}
                  id="outlined-basic"
                  label="User ID"
                  variant="outlined"
                  {...register("email", {
                    required: "User ID is required",
                  })}
                  // error={!!errors.email}
                  inputRef={register("email")}
                />
                {errors.email && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "25px",
                    }}
                  >
                    {errors.email.message}
                  </div>
                )}
              </Box>
              <Box sx={{ marginBottom: "8px" }}>
                <TextField
                  sx={styles.textfieldres}
                  id="outlined-basic"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  {...register("password", {
                    required: "Password is required",
                  })}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  inputRef={register("password")}
                />
                {errors.password && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "25px",
                    }}
                  >
                    {errors.password.message}
                  </div>
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  paddingRight: "20px",
                  marginTop: "-6px",
                  cursor: "pointer",
                  color: "blue", // Add this line to set the text color to blue
                }}
                onClick={handleClick}
              >
                Forgot your password?
              </Box>
              <Box sx={{ marginBottom: "8px" }}>
                <Button
                  sx={styles.btnres}
                  type="submit"
                  variant="contained"
                  disabled={!isValid || isSubmitting}
                >
                  Sign In
                </Button>
              </Box>
            </form>

            <Box sx={{ marginTop: "25px", color: "#6B6B6B" }}>
              <Box>
                Don't have an account?
                <a
                  onClick={() => navigate("/insurance-register")}
                  style={{
                    color: "#002C51 ",
                    cursor: "pointer",
                    fontWeight: 600,
                  }}
                >
                  &nbsp;Create account
                </a>
              </Box>
            </Box>
            <Box
              sx={{
                border: "1px solid black",
                marginTop: "20px",
                marginBottom: "-5px",
              }}
            ></Box>
            <br></br>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                // marginTop:"-1px",
                // border:"1px solid red",
              }}
            >
              <Box
                sx={{
                  width: "50%",
                  margin: "-6px 0px 0px -10px",
                  cursor: "pointer",
                  display: "flex",
                }}
                onClick={() => window.open("tel:+918586023109", "_self")}
              >
                <div style={{ fontSize: "14px", color: "#002C51" }}>
                  <PhoneIcon
                    sx={{
                      margin: "8px 3px 0px 4px",
                      color: "#002C51",
                      width: 18,
                      height: 16,
                    }}
                    fontSize="small"
                  />

                  {/* <b>Contact us</b> */}
                </div>
                <div style={{ fontSize: "16px", marginTop: "5px" }}>
                  +91 124 668 7770
                </div>
              </Box>
              <Box
                sx={{
                  width: "50%",
                  margin: "0px 5px 0px 0px",
                  display: "flex",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    color: "#002C51",
                    marginLeft: "-5px",
                  }}
                >
                  <MailIcon
                    sx={{ margin: "3px 5px -3px -5px", color: "#002C51" }}
                    fontSize="small"
                  />
                </div>
                <a
                  href="mailto:insurance@investek.in"
                  style={{ color: "blue", textDecoration: "none" }}
                >
                  <div style={{ fontSize: "16px" }}>insurance@investek.in</div>
                </a>
              </Box>
            </Box>
          </Box>
        </span>
      ) : (
        <span>
          {" "}
          <Box sx={styles.formbox}>
            <Box
              onClick={handleCancel}
              sx={{
                textAlign: "right",
                cursor: "pointer",
                color: "#666666",
              }}
            >
              <CloseIcon />
            </Box>
            <div style={{ margin: "0px 0px 10px 0px" }}>Welcome to Amigo!</div>
            <div style={{ fontSize: "22px", marginBottom: "25px" }}>
              <b>Sign in to your Account</b>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box sx={{ marginBottom: "8px" }}>
                <TextField
                  sx={styles.textfield}
                  id="outlined-basic"
                  label="User ID"
                  variant="outlined"
                  {...register("email", {
                    required: "User ID is required",
                  })}
                  // error={!!errors.email}
                  inputRef={register("email")}
                />
                {errors.email && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "25px",
                    }}
                  >
                    {errors.email.message}
                  </div>
                )}
              </Box>
              {/* <Box sx={{ marginBottom: "8px" }}>
            <TextField
              sx={styles.textfield}
              id="outlined-basic"
              label="Password"
              type="password"
              variant="outlined"
              {...register("password", {
                required: "Password is required",
              })}
              // error={!!errors.password}
              inputRef={register("password")}
            />
            {errors.password && (
              <div
                style={{
                  color: "red",
                  fontSize: "14px",
                  textAlign: "left",
                  marginLeft: "10px",
                }}
              >
                {errors.password.message}
              </div>
            )}
          </Box> */}
              <Box sx={{ marginBottom: "8px" }}>
                <TextField
                  sx={styles.textfield}
                  id="outlined-basic"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  {...register("password", {
                    required: "Password is required",
                  })}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  inputRef={register("password")}
                />
                {errors.password && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "25px",
                    }}
                  >
                    {errors.password.message}
                  </div>
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  paddingRight: "20px",
                  marginTop: "-6px",
                  cursor: "pointer",
                  color: "blue",
                }}
                onClick={handleClick}
              >
                Forgot your password?
              </Box>
              <Box sx={{ marginBottom: "8px" }}>
                <Button
                  sx={styles.btn}
                  type="submit"
                  variant="contained"
                  disabled={!isValid || isSubmitting}
                >
                  Sign In
                </Button>
              </Box>
            </form>

            <Box sx={{ marginTop: "25px", color: "#6B6B6B" }}>
              <Box>
                Don't have an account?
                <a
                  onClick={() => navigate("/insurance-register")}
                  style={{
                    color: "#002C51 ",
                    cursor: "pointer",
                    fontWeight: 600,
                  }}
                >
                  &nbsp;Create account
                </a>
              </Box>
            </Box>
            <Box
              sx={{
                border: "1px solid black",
                marginTop: "20px",
                marginBottom: "-15px",
              }}
            ></Box>
            <br></br>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  width: "40%",
                  cursor: "pointer",
                  display: "flex",
                  marginLeft: "1rem",
                }}
                onClick={() => window.open("tel:+918586023109", "_self")}
              >
                <div style={{ fontSize: "16px", color: "#002C51" }}>
                  <PhoneIcon
                    sx={{
                      margin: "8px 5px 0px 0px",
                      color: "#002C51",
                      width: 18,
                      height: 16,
                    }}
                    fontSize="small"
                  />

                  {/* <b>Contact us</b> */}
                </div>
                <div style={{ fontSize: "16px", marginTop: "5px" }}>
                  +91 124 668 7770
                </div>
              </Box>
              <Box
                sx={{ width: "20%", display: "flex", justifyContent: "center" }}
              >
                <Box
                  sx={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#e6e6e6",
                    marginTop: "10px",
                    // marginRight: "18px"
                  }}
                >
                  <Typography sx={{ fontSize: "16px" }}>or</Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  width: "40%",
                  display: "flex",
                  marginRight: "1rem",
                  marginTop: "3px",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    color: "#002C51",
                    marginLeft: "-5px",
                  }}
                >
                  <MailIcon
                    sx={{ margin: "3px 5px -3px 0px", color: "#002C51" }}
                    fontSize="small"
                  />
                </div>
                <a
                  href="mailto:insurance@investek.in"
                  style={{ color: "blue", textDecoration: "none" }}
                >
                  <div style={{ fontSize: "16px" }}>insurance@investek.in</div>
                </a>
              </Box>
            </Box>
          </Box>
        </span>
      )}
    </>
  );
};

export default InsSignin;

const styles = {
  formbox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    // minHeigh: "calc(100vh - 250px)",
    // height: "calc(100vh - 300px)",
    minHeigh: "430px",
    width: "450px",
    paddingBottom: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  formboxresponsive: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    // minHeigh: "calc(100vh - 250px)",
    // height: "calc(100vh - 300px)",
    height: "440px",
    width: "335px",
  },
  formboxtwo: {
    position: "absolute",
    top: "85%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "40px",
    width: "420px",
  },
  btn: {
    marginTop: "1em",
    width: "400px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    width: "400px",
  },

  btnres: {
    marginTop: "1em",
    width: "300px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfieldres: {
    width: "300px",
  },

  emailLink: {
    // paddingLeft: "3.8rem",
    color: "#666666",
    fontSize: "14px",
    textDecoration: "none",
    transition: "color 0.3s",
    "&:hover": {
      color: "#002C51 ",
    },
  },
};
